import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Show,
  SimpleShowLayout,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  DateField,
  FilterButton,
  CreateButton,
  TopToolbar,
  SearchInput,
  SelectField,
  SelectInput,
  BooleanInput,
  BooleanField,
} from "react-admin";
import ExportAllButton from "../components/ExportAllButton";
import DynamicDropdownFilter from "../components/DynamicDropdownFilter";
import { EMPLOYEE_STATUS_CHOICES } from "../consts";

const employeeFilters = [
  <SearchInput source="q_name_title_email" alwaysOn />,
  <DynamicDropdownFilter label="Name" source="name" resource="rmf/employees" />,
  <DynamicDropdownFilter
    label="Email"
    source="email"
    resource="rmf/employees"
  />,
  <DynamicDropdownFilter
    label="Division"
    source="division"
    resource="rmf/employees"
  />,
  <DynamicDropdownFilter
    label="Department"
    source="department"
    resource="rmf/employees"
  />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportAllButton />
  </TopToolbar>
);

export const EmployeeList = () => (
  <List filters={employeeFilters} perPage={25} actions={<ListActions />}>
    <Datagrid rowClick="show">
      <TextField source="name" />
      <TextField source="title" />
      <TextField source="email" />
      <TextField source="division" />
      <TextField source="department" />
      <TextField source="manager" />
      <BooleanField source="executiveOwner" />
      <SelectField source="status" choices={EMPLOYEE_STATUS_CHOICES} />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);

export const EmployeeShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="title" />
      <TextField source="email" />
      <TextField source="division" />
      <TextField source="department" />
      <TextField source="manager" />
      <BooleanField source="executiveOwner" />
      <SelectField source="status" choices={EMPLOYEE_STATUS_CHOICES} />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);

export const EmployeeEdit = () => {
  return (
    <Edit redirect="show">
      <SimpleForm>
        <TextInput source="name" />
        <TextInput source="title" />
        <TextInput source="email" />
        <TextInput source="division" />
        <TextInput source="department" />
        <TextInput source="manager" />
        <BooleanInput source="executiveOwner" />
        <SelectInput source="status" choices={EMPLOYEE_STATUS_CHOICES} />
      </SimpleForm>
    </Edit>
  );
};

export const EmployeeCreate = () => {
  return (
    <Create redirect={"show"}>
      <SimpleForm>
        <TextInput source="name" />
        <TextInput source="title" />
        <TextInput source="email" />
        <TextInput source="division" />
        <TextInput source="department" />
        <TextInput source="manager" />
        <BooleanInput source="executiveOwner" />
        <SelectInput source="status" choices={EMPLOYEE_STATUS_CHOICES} />
      </SimpleForm>
    </Create>
  );
};
